export default "__VITE_ASSET__e361afa2__"